module.exports = __webpack_public_path__ + "media/images/profile/photo-request-864fbcb0d62fae68f1642e157e0d4b12.svg";